import axios from 'axios'

const GROUP = process.env.VUE_APP_GROUP

class GroupCalls {

  create(group) {
    return axios.post(GROUP + "create/", { group })
    .then(response => response.data.group);
  }

  get(id) {
    return axios.get(GROUP + "id/" + id)
    .then(response => response.data.group);
  }

  getIds(ids) {
    return axios.get(GROUP + "id/", { ids })
    .then(response => response.data.groups);
  }

  getAll() {
    return axios.get(GROUP + "all/")
    .then(response => response.data.groups);
  }

  getChapters(ids) {
    return axios.post(GROUP + "child/", { ids, type: 'c' })
    .then(response => response.data.children);
  }

  filter(zoom = null, area = null, parent = null) {
    return axios.post(GROUP + "filter/", { zoom, area, parent })
    .then(response => response.data.groups);
  }

  area(center, zoom) {
    return axios.post(GROUP + "area/", { center, zoom })
    .then(response => response.data.groups);
  }

  addChapter(groupId, chapterId) {
    return axios.post(GROUP + `child/${groupId}/chapter`, { childId: chapterId })
    .then(response => response.data.parentGroup);
  }

  search(query, options) {
    return axios.post(GROUP + "all/", { query, options })
    .then(response => response.data.groups);
  }

}

const groupCalls = new GroupCalls();
export default groupCalls;
